(ns machtfit.widgets.box
  (:require [machtfit.widgets.icon :as icon]))

(defn info [{:keys [icon content]}]
  [:div.flex.gap-4.self-stretch.border.p-4.rounded-xl.border-solid.border-gray-300
   icon
   content])

(defn notification [{:keys [icon-leading content color] :or {color :brand}}]
  [:div.flex.gap-4.self-stretch.border.p-4.rounded-xl.border-solid
   {:class (case color
             :raspberrypink "border-raspberrypink-25 bg-raspberrypink-25 text-raspberrypink-500"
             :sunshineyellow "border-sunshineyellow-100 bg-sunshineyellow-50 text-sunshineyellow-900"
             :brand "border-brand-50 bg-brand-50 text-brand-500"
             "border-gray-300 bg-gray-50 text-gray-800")}
   (when icon-leading
     [:div.flex.w-10.h-10.justify-center.items-center.rounded-full {:class "p-2.5"}
      [icon/outline icon-leading {:width "h-6"
                                  :height "w-6"
                                  :stroke "stroke-current"}]])
   [:div.flex.items-center content]])
